import UiPageList from "./UiPageList";
import DtoListItemOrderPoolCargo from "./DtoListItemOrderPoolCargo";
import { EnumOrderPoolStatus, EnumOrderPoolStatusOption } from "./EnumOrderPoolStatus";
import { EnumOrderStatus, EnumOrderStatusOption } from "./EnumOrderStatus";

/**
 * 委托书-货物清单分页列表
 * @description 自动生成的代码,请勿修改
 */
export default class DtoPageListOrderPoolCargo extends UiPageList<DtoListItemOrderPoolCargo, string> {
    constructor() {
        //无参构造函数
        super()
        this.Lock = false;
        this.PageIndex = 0;
        this.PageSize = 0;
        this.TotalCount = 0;
        this.TotalPages = 0;
        this.HasPrevPages = false;
        this.HasNextPages = false;
    }

    [proName: string]: any;
    /**
     * 锁定
     */
    Lock?: boolean;
    /**
     * 状态
     */
    Status?: EnumOrderPoolStatus;
    /**
     * 订单状态
     */
    OrderStatus?: EnumOrderStatus;
}

/**
 * 委托书-货物清单分页列表-表单校验
 */
export const DtoPageListOrderPoolCargoRules = {
}
